import { FC } from 'react';

import { RatePlanVasBlock } from './ConnectedVasBlocks';
import { useVasModalControls } from './useVasModalControls';

export const ModalRatePlanVasBlock: FC = () => {
    const { openModal } = useVasModalControls();

    return <RatePlanVasBlock onClick={openModal} />;
};
